import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getTypeOfProperty,
  getLocationList,
  getQuestionsList,
} from "../../services/apiEndPoints";
import { GetQuestionsListPayload } from "../../types";

export const getTypeOfPropertyThunk = createAsyncThunk(
  "access/getTypeOfProperty",
  async (payload: { category_id: number }) => {
    try {
      const response = await getTypeOfProperty(payload.category_id);
      return response.data;
    } catch (error: any) {
      return error;
    }
  }
);

export const getLocationListThunk = createAsyncThunk(
  "access/getLocationList",
  async () => {
    try {
      const response = await getLocationList();
      return response.data;
    } catch (error: any) {
      return error;
    }
  }
);

export const getQuestionsListThunk = createAsyncThunk(
  "access/getQuestionsList",
  async (payload: GetQuestionsListPayload) => {
    try {
      const response = await getQuestionsList(
        payload.category_id,
        payload.location_id
      );
      return response.data;
    } catch (error: any) {
      return error;
    }
  }
);

export const getTypeOfLocationThunk = createAsyncThunk(
  "access/getTypeOfLocation",
  async (payload: GetQuestionsListPayload) => {
    try {
      const response = await getQuestionsList(
        payload.category_id,
        payload.location_id
      );
      return response.data;
    } catch (error: any) {
      return error;
    }
  }
);
